import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom';

interface Props {
    name: string;
    children: any;
    autoplay?: boolean;
    persist?: boolean;
}
export const ModalGenerico = ({ name, autoplay = false, persist = false, children }: Props) => {
    const buttonRef = useRef<HTMLButtonElement>(null);
    const location = useLocation();

    useEffect(() => {
        if (persist) {
            const alreadyShown = sessionStorage.getItem("modal-" + name);
            if (!alreadyShown && buttonRef.current && autoplay) {
                buttonRef.current.click();
                sessionStorage.setItem("modal-" + name, "true");
            }
        }else{
            if (buttonRef.current && autoplay) {
                buttonRef.current.click();
                sessionStorage.setItem("modal-" + name, "true");
            }
        }
    }, []);

    useEffect(() => {
        return () => {
            const modalEl = document.getElementById(name);
            if (modalEl?.classList.contains("show")) {
                modalEl.classList.remove("show");
                modalEl.setAttribute("aria-hidden", "true");
                modalEl.setAttribute("style", "display: none");

                document.body.classList.remove("modal-open");
                document.body.style.removeProperty("padding-right");
                const backdrops = document.querySelectorAll(".modal-backdrop");
                backdrops.forEach((b) => b.remove());
            }
        };
    }, [location]);

    return (
        <>
            <button
                ref={buttonRef}
                type="button"
                className="d-none"
                data-bs-toggle="modal"
                data-bs-target={"#" + name}
            >
            </button>

            <div
                className="modal fade"
                id={name}
                tabIndex={-1}
                aria-labelledby={"modal " + name}
                aria-hidden="true"
                data-bs-backdrop="static"
                data-bs-keyboard="false"
            >
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content p-3">
                        {children}
                    </div>
                </div>
            </div>
        </>
    );
}
